<div class="row">
            
    <div class="col-md-4 flex align-item-vertical-center">
      <div *ngIf="isALetterLowerCase"><mat-icon class="colorNa">check_circle</mat-icon></div>
      <div *ngIf="!isALetterLowerCase"><mat-icon class="icon-no-accept">panorama_fish_eye</mat-icon></div>
      <div>1 letra minúscula</div>
    </div>

    <div class="col-md-4 flex align-item-vertical-center">
      <div *ngIf="isAlmost8Charts"><mat-icon class="colorNa">check_circle</mat-icon></div>
      <div *ngIf="!isAlmost8Charts"><mat-icon class="icon-no-accept">panorama_fish_eye</mat-icon></div>
      <div>8-12 caracteres</div>
    </div>

    <div class="col-md-4 flex align-item-vertical-center">
      <div *ngIf="isAChartEspecial"><mat-icon class="colorNa">check_circle</mat-icon></div>
      <div *ngIf="!isAChartEspecial"><mat-icon class="icon-no-accept">panorama_fish_eye</mat-icon></div>
      <div>1 caracter especial:<br>$@!%*?&</div>
    </div>

  </div>

  <div class="row">
    
    <div class="col-md-4 flex align-item-vertical-center">
      <div *ngIf="isALetterUpperCase"><mat-icon class="colorNa">check_circle</mat-icon></div>
      <div *ngIf="!isALetterUpperCase"><mat-icon class="icon-no-accept">panorama_fish_eye</mat-icon></div>
      <div>1 letra mayúscula</div>
    </div>

    <div class="col-md-4 flex align-item-vertical-center">
      <div *ngIf="isANumber"><mat-icon class="colorNa">check_circle</mat-icon></div>
      <div *ngIf="!isANumber"><mat-icon class="icon-no-accept">panorama_fish_eye</mat-icon></div>
      <div>Al menos 1 número</div>
    </div>

  </div>
